export class CostCenterCriteriaValueModel {
  public id: number;
  public code: string;
  public value: string = null;

  constructor() {}

  fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
